// extracted by mini-css-extract-plugin
export default {"container":"ProfileExerciseCard_container__UwelM","button":"ProfileExerciseCard_button__rSO3i","exerName":"ProfileExerciseCard_exerName__cCRBo"};